import { BusinessSellingOptions } from '@/models/businesses/business-selling-options';
import { axiosService } from '.';

export default class BusinessSellingOptionsService {
    public async getSellingOptions(businessId: number): Promise<BusinessSellingOptions> {
        return new BusinessSellingOptions((await axiosService.instance.get(`businesses/organization/selling-options/${businessId}`)).data);
    }

    public async updateSellingOptions(businessId: number, sellingOptions: BusinessSellingOptions): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/selling-options/${businessId}/update`, sellingOptions)).data;
    }
}

export const businessSellingOptionsService = new BusinessSellingOptionsService();
